module.exports = __webpack_public_path__ + "static/media/rocketIllustration.9d471f5a.svg";